export const habaCountries = {
  countries: {
    AL: 'Albanie',
    AD: 'Andorre',
    BE: 'Belgique',
    BA: 'Bosnie-Herzégovine',
    BG: 'Bulgarie',
    DE: 'Allemagne',
    DK: 'Danemark',
    EE: 'Estonie',
    FI: 'Finlande',
    FR: 'France',
    FO: 'Îles Féroé',
    GI: 'Gibraltar',
    GR: 'Grèce',
    GL: 'Groenland',
    VA: 'Saint-Siège (État de la Cité du Vatican)',
    IE: 'Irlande',
    IS: 'Islande',
    IT: 'Italie',
    HR: 'Croatie',
    LV: 'Lettonie',
    LI: 'Liechtenstein',
    LT: 'Lituanie',
    LU: 'Luxembourgeois',
    MT: 'Malte',
    MK: 'Macédoine',
    MD: 'Moldavie',
    MC: 'Monaco',
    ME: 'Monténégro',
    NL: 'Pays-Bas',
    NO: 'Norvège',
    PL: 'Pologne',
    PT: 'Portugal',
    RO: 'Roumanie',
    RU: 'Fédération de Russie',
    SM: 'Saint-Marin',
    SE: 'Suède',
    CH: 'Suisse',
    RS: 'Serbie',
    SK: 'Slovaquie',
    SI: 'Slovénie',
    ES: 'Espagne',
    CZ: 'République tchèque',
    TR: 'Turquie',
    UA: 'Ukraine',
    HU: 'Hongrie',
    BY: 'Biélorussie',
    CY: 'Chypre',
    AT: 'Autriche',
  },
  languages: {
    en: 'Anglais',
    de: 'Allemand',
    ch: 'Suisse',
    fr: 'Français',
  },
};
